module.exports = __webpack_public_path__ + "static/media/whale.03be1277.png";